import { toast } from "sonner";

export default function PinDisplay({ pin, podAddress, startsAt, endsAt }) {
  if (!pin) return null;
  const digits = pin.split("");
  const start = startsAt ? new Date(startsAt) : null;
  const end = endsAt ? new Date(endsAt) : null;
  const fmt = (d) =>
    d
      ? d.toLocaleString("en-US", {
          weekday: "short",
          month: "short",
          day: "numeric",
          hour: "numeric",
          minute: "2-digit",
        })
      : "";

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(pin);
      toast.success("PIN copied to clipboard");
    } catch {
      toast.error("Could not copy. Long-press to select.");
    }
  };

  return (
    <div
      className="rounded-[40px] bg-brand-blue text-white p-8 md:p-10 relative overflow-hidden border-b-8 border-brand-red"
      data-testid="pin-display"
    >
      <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-brand-gold/10" />
      <div className="absolute -bottom-24 -left-24 w-72 h-72 rounded-full bg-brand-red/10" />

      <div className="relative">
        <div className="flex items-center justify-between flex-wrap gap-3 mb-6">
          <div>
            <p className="text-[10px] font-black uppercase tracking-[0.4em] text-brand-gold">
              <i className="fas fa-lock mr-2" />
              Smart Pod Pin
            </p>
            <h2 className="text-2xl md:text-3xl font-black uppercase tracking-tightest mt-1">
              Park Hill • Holly St
            </h2>
          </div>
          <span className="bg-brand-gold text-brand-blue px-4 py-2 rounded-full text-[10px] font-black uppercase tracking-widest pin-pulse">
            <i className="fas fa-bolt mr-1" /> Active
          </span>
        </div>

        <div className="flex flex-wrap gap-2 md:gap-3 mb-6" data-testid="pin-digits">
          {digits.map((d, i) => (
            <div
              key={i}
              className="w-12 h-16 md:w-16 md:h-20 rounded-2xl bg-white text-brand-blue flex items-center justify-center text-3xl md:text-5xl font-black"
            >
              {d}
            </div>
          ))}
        </div>

        <div className="grid sm:grid-cols-3 gap-4 text-[11px]">
          <div>
            <p className="font-black uppercase tracking-widest text-brand-gold mb-1">Pickup</p>
            <p className="font-bold">{fmt(start)}</p>
          </div>
          <div>
            <p className="font-black uppercase tracking-widest text-brand-gold mb-1">Return By</p>
            <p className="font-bold">{fmt(end)}</p>
          </div>
          <div>
            <p className="font-black uppercase tracking-widest text-brand-gold mb-1">Address</p>
            <p className="font-bold">{podAddress || "3475 Holly St, Denver"}</p>
          </div>
        </div>

        <div className="mt-6 flex flex-wrap gap-3">
          <button
            onClick={copy}
            className="bg-brand-gold text-brand-blue px-5 py-3 rounded-xl font-black text-xs uppercase tracking-widest hover:bg-amber-300 transition-colors"
            data-testid="pin-copy-button"
          >
            <i className="fas fa-copy mr-2" /> Copy PIN
          </button>
          <a
            href="https://maps.google.com/?q=3475+Holly+St,+Denver,+CO+80207"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white/10 text-white px-5 py-3 rounded-xl font-black text-xs uppercase tracking-widest hover:bg-white/20 transition-colors border border-white/20"
            data-testid="pin-directions-link"
          >
            <i className="fas fa-map-marker-alt mr-2" /> Directions
          </a>
        </div>
      </div>
    </div>
  );
}
